// Generated by CoffeeScript 2.7.0
import DateTimePickerPopover from 'trunks/vue/admin/components/date_time_picker_popover.js';

import {
  DurationThresholdSettingMixin,
  DurationThresholdSettingListMixin
} from 'trunks/vue/share/mixins/yet_another_workflow/assignment_settings/duration_threshold.js';

import TimeSpan from 'trunks/vue/admin/components/time_span.js';

export var ThresholdSettingComp = {
  mixins: [DurationThresholdSettingMixin],
  components: {
    'datetime-picker': DateTimePickerPopover,
    'time-span': TimeSpan
  },
  template: `<div class="form-field inline">
  <div class="form-field-head">
    <div class="form-field-title">{{ settingable.name }}</div>
  </div>
  <div class="form-field-input-container">
    <div class="form-field-input">
      <div class="options">
        <div class="option-item">
          <label>
            <input hidden
                   type='checkbox'
                   @change.stop='checkedChangeFunc'
                   :checked="thresholdType == 'date'"
                   value='date' />
            <i class="slp-circle-o"></i>
            <span class="option-label">具体日期</span>
          </label>
          <datetime-picker position='bottom left'
                          customClass='option-addition'
                          :limitStart='new Date()'
                          @valueChanged='valueChangedFunc'
                          v-show="thresholdType == 'date'">
            <div class="input-control right-addon grow-input" slot='trigger'>
              <div class="controlled-input">
                <div v-if='value.date'>{{ value.date }}</div>
                <div class="placeholder" v-else>请选择</div>
              </div>
              <div class="addon destroy-btn" @click.stop='destroyDateValue' v-if='value.date'>
                <i class="slp-minus-circle"></i>
              </div>
              <div class="addon" v-else>
                <i class="slp-date-time"></i>
              </div>
            </div>
          </datetime-picker>
        </div>
        <div class="option-item">
          <label>
            <input hidden
                   type='checkbox'
                   @change.stop='checkedChangeFunc'
                   :checked="thresholdType == 'duration'"
                   value='duration' />
            <i class="slp-circle-o"></i>
            <span class="option-label">时长</span>
          </label>
          <time-span :customClass="['option-addition', 'vertical-middle']"
                     :duration='value.duration'
                     @valueChanged='valueChangedFunc'
                     v-show="thresholdType == 'duration'" />
        </div>
      </div>
    </div>
  </div>
</div>`
};

// DurationThresholdSettingList
export var DurationThresholdAssignmentSetting = {
  mixins: [DurationThresholdSettingListMixin],
  components: {
    'settingable-comp': ThresholdSettingComp
  },
  template: `<div class="form-field duration-threshold-setting">
  <div class="form-field-head">
    <div class="form-field-title">设置时间限制</div>
  </div>
  <div class="form-field-input-container">
    <div class="form-field-input">
      <settingable-comp v-for='settingable in settingables'
                        :settingable='settingable'
                        :key='settingable.id'
                        ref='thresholdSettingCompRef'/>
    </div>
  </div>
</div>`
};

export default DurationThresholdAssignmentSetting;
